/// WAMP module HikVisionDB, supported by Jiang Dunchun(jiangdunchun@outlook.com)

const WampCommon = require('./WampCommon.js');

var HikVisionDB = {
    // description: 
    // callback: String
    // arguments: strLog:String 
    EnterLeaveSelect: function (strLog, callback) {
        var args = new Array(strLog);
        WampCommon.WampCall('HikVisionDB', 'EnterLeaveSelect', args, callback);
    },
    // description: 
    // callback: String
    // arguments: strFacePicInfor:String FacePic:String 
    AppointmentInsert: function (strFacePicInfor, FacePic, callback) {
        var args = new Array(strFacePicInfor, FacePic);
        WampCommon.WampCall('HikVisionDB', 'AppointmentInsert', args, callback);
    },
    // description: 
    // callback: String
    // arguments: strFace:String FacePic:String 
    AppointmentUpdate: function (strFace, FacePic, callback) {
        var args = new Array(strFace, FacePic);
        WampCommon.WampCall('HikVisionDB', 'AppointmentUpdate', args, callback);
    },
    // description: 
    // callback: String
    // arguments: strFace:String 
    AppointmentSelect: function (strFace, callback) {
        console.log('调用:AppointmentSelect')
        var args = new Array(strFace);
        WampCommon.WampCall('HikVisionDB', 'AppointmentSelect', args, callback);
    },
    // description: 
    // callback: String
    // arguments: strFace:String 
    AppointmentDelete: function (strFace, callback) {
        var args = new Array(strFace);
        WampCommon.WampCall('HikVisionDB', 'AppointmentDelete', args, callback);
    },
    // description: 
    // callback arguments: EnterLeaveLogMessage:String 
    AddEnterLeaveLogChanged: function (callback) {
        WampCommon.WampSubscribe('HikVisionDB', 'EnterLeaveLogChanged', callback);
    },
    // description: 
    // callback arguments: EnterLeaveLogMessage:String 
    DeleteEnterLeaveLogChanged: function (callback) {
        WampCommon.WampUnsubscribe('HikVisionDB', 'EnterLeaveLogChanged', callback);
    },
};

module.exports = HikVisionDB;